<template>
  <div>
    <v-toolbar dense flat>
      <v-layout row>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search code ref. / type / description"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filteredUserList"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{
            pagination.page * pagination.rowsPerPage -
            (pagination.rowsPerPage - props.index - 1)
          }}
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.transaction_partner_order_code != null"
        >
          {{ props.item.transaction_partner_order_code }}
        </td>
        <td class="text-xs-center" v-else>-</td>
        <td class="text-xs-center">
          {{ props.item.transaction_partner_type }}
        </td>
        <td class="text-xs-center">
          {{ props.item.transaction_partner_description }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.create_at).format("YYYY-MM-DD HH:mm น.") }}
        </td>
        <td class="text-xs-center">
          {{ props.item.transaction_partner_we_credit }}
        </td>
        <td>
          <v-btn
            depressed
            disabled
            small
            v-if="props.item.transaction_partner_type == 'Top Up'"
          >
            <img src="@/assets/back-office/icons/eye.svg" alt="" width="15px" />
            <h4 class="white--text ml-1">VIEW</h4>
          </v-btn>
          <v-btn
            depressed
            disabled
            small
            v-else-if="props.item.transaction_partner_type == 'Add Credit'"
          >
            <img src="@/assets/back-office/icons/eye.svg" alt="" width="15px" />
            <h4 class="white--text ml-1">VIEW</h4>
          </v-btn>
          <v-btn
            :to="
              `/weserve_admin_login/-/manager-manage/transaction/-/-/${
                props.item.transaction_partner_id
              }/${props.item.transaction_partner_type}/withdraw`
            "
            class="blue"
            depressed
            small
            v-else-if="props.item.transaction_partner_type == 'Withdraw'"
          >
            <img src="@/assets/back-office/icons/eye.svg" alt="" width="15px" />
            <h4 class="white--text ml-1">VIEW</h4>
          </v-btn>
          <v-btn
            small
            v-else
            :to="`/weserve_admin_login/-/manager-manage/transaction/-/-/${props.item.transaction_partner_id}/${props.item.transaction_partner_type}`"
            class="blue"
          >
            <img src="@/assets/back-office/icons/eye.svg" alt="" width="15px" />
            <h4 class="white--text ml-1">VIEW</h4>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loadingMessage == true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else>
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
      </template>
    </v-data-table>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    errSnackbar: "",
    snackBarMsg: "",
    valid: false,
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    dialog: false,
    headers: [
      {
        text: "No.",
        value: "transaction_partner_id",
        sortable: false,
        align: "center",
      },
      {
        text: "Code Ref.",
        value: "transaction_partner_order_code",
        sortable: false,
        align: "center",
      },
      {
        text: "Type",
        sortable: false,
        value: "transaction_partner_type",
        align: "center",
      },
      {
        text: "Discription",
        sortable: false,
        value: "transaction_partner_description",
        align: "center",
      },
      {
        text: "Date/Time",
        value: "create_at",
        sortable: false,
        align: "center",
      },
      {
        text: "Credit",
        value: "transaction_partner_we_credit",
        sortable: false,
        align: "center",
      },
      {
        text: "Detail",
        value: "",
        align: "center",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapState({
      indexEditLoading: (state) => state.fetchUserBack.indexEditLoading,
      userData: (state) => state.fetchUserBack.userData,
      settransactionById: (state) => state.fetchUserBack.settransactionById,
    }),

    filteredUserList() {
      return this.settransactionById.filter(
        (val) =>
          (
            val.transaction_partner_order_code +
            " " +
            val.transaction_partner_type
          )
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.transaction_partner_description
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      fetchtransactionByid: "fetchUserBack/fetchtransactionByid",
    }),
    async getDataByid() {
      let idtransaction = this.$route.params.user_partner_id;
      this.loadingMessage = true;
      await this.fetchtransactionByid({
        manager_id: idtransaction,
      });
      this.loadingMessage = false;
    },
  },
  created() {
    this.getDataByid();
  },
};
</script>

<style>
.body__district::-webkit-scrollbar {
  display: none;
  max-height: 150px;
  overflow: auto;
}
</style>
